import { useState } from "react";
import { motion } from "framer-motion";
import { PhoneCall, ArrowUpRight } from "lucide-react";
import { submitEnquiry } from "@/lib/api";


const SLOTS = ["Morning (9–12)", "Afternoon (12–5)", "Evening (5–9)", "Any time"];

export default function Callback() {
  const [form, setForm] = useState({ name: "", phone: "", slot: SLOTS[0], note: "" });
  const [status, setStatus] = useState({ state: "idle", msg: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      setStatus({ state: "error", msg: "Please add your name and phone." });
      return;
    }
    setStatus({ state: "loading", msg: "Booking your call…" });
    try {
      await submitEnquiry("/callbacks", form);
      setStatus({ state: "ok", msg: "Your request is saved. I'll get in touch to confirm a call time." });
      setForm({ name: "", phone: "", slot: SLOTS[0], note: "" });
    } catch (err) {
      setStatus({ state: "error", msg: `${err.message || "Couldn't book right now."} Email me at workwithayush858@gmail.com.` });
    }
  };

  return (
    <section id="callback" className="section callback" data-testid="callback-section">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="callback__card"
      >
        <div className="callback__copy">
          <span className="overline">◆ Faster than a brief · 30-sec form</span>
          <h2 className="callback__title serif" data-testid="callback-heading">
            Want a quick call <span className="italic">instead?</span>
          </h2>
          <p className="callback__lede">
            Drop your number and a time that works — I&apos;ll ring you. I’ll confirm the details with you.
          </p>
          <div className="callback__badge">
            <PhoneCall size={18} strokeWidth={1.6} />
            <span>Reply window: same business day</span>
          </div>
        </div>

        <form className="callback__form" onSubmit={submit} data-testid="callback-form">
          <div className="cb-row">
            <div className="field">
              <label className="overline" htmlFor="callback-name">Name</label>
              <input id="callback-name" name="name" maxLength={120} autoComplete="name"
                type="text"
                value={form.name}
                onChange={set("name")}
                placeholder="Jane Doe"
                required
                data-testid="callback-name-input"
              />
            </div>
            <div className="field">
              <label className="overline" htmlFor="callback-phone">Phone</label>
              <input id="callback-phone" name="phone" maxLength={32} autoComplete="tel"
                type="tel"
                value={form.phone}
                onChange={set("phone")}
                placeholder="+1 555 010 9988"
                required
                data-testid="callback-phone-input"
              />
            </div>
          </div>

          <div className="field">
            <span id="slot-label" className="overline">Best time to reach you (India time)</span>
            <div className="chips" role="radiogroup" aria-labelledby="slot-label" data-testid="callback-slot-chips">
              {SLOTS.map((s) => (
                <label key={s} className={`chip ${form.slot === s ? "chip--on" : ""}`}>
                  <input type="radio" name="slot" value={s} checked={form.slot === s} onChange={() => setForm({ ...form, slot: s })} />
                  {s}
                </label>
              ))}
            </div>
          </div>

          <div className="field">
            <label className="overline" htmlFor="callback-note">Anything I should know? <span className="overline--muted">(optional)</span></label>
            <input id="callback-note" name="note" maxLength={2000} autoComplete="off"
              type="text"
              value={form.note}
              onChange={set("note")}
              placeholder="Quick context — brand, timeline, budget…"
              data-testid="callback-note-input"
            />
          </div>

          <button type="submit" className="submit-btn" disabled={status.state === "loading"} data-testid="callback-submit-btn">
            <span>{status.state === "loading" ? "Booking…" : "Request the call"}</span>
            <ArrowUpRight size={18} strokeWidth={1.5} />
          </button>

          {status.msg && (
            <div className={`form-status form-status--${status.state}`} data-testid="callback-status-message" role="status">
              {status.msg}
            </div>
          )}
        </form>
      </motion.div>
    </section>
  );
}
